/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring>): BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring(), model);
        BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring>): BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring.newInstance(<BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
